
  var _styles = {
  "rich-text-list-container": {
    "flexDirection": "row"
  },
  "rich-text-list-subtitle-text": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)",
    "lineHeight": "0.53333rem"
  },
  "rich-text-list-title-text": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.37333rem",
    "color": "rgb(32,32,32)",
    "lineHeight": "0.53333rem"
  }
};



  module.exports = _styles;
  